"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Radios = exports._Radios = void 0;
var react_1 = __importStar(require("react"));
var check_focus_1 = require("../../../utils/check-focus");
var with_form_manager_1 = require("../../../utils/with-form-manager");
var form_field_set_component_1 = require("../../base/form-field-set/form-field-set-component");
exports._Radios = (0, react_1.forwardRef)(function (_a, ref) {
    var children = _a.children, name = _a.name, onChange = _a.onChange, props = __rest(_a, ["children", "name", "onChange"]);
    var isFocused = (0, check_focus_1.checkFocus)(props, ref);
    var _b = (0, react_1.useState)(""), value = _b[0], setValue = _b[1];
    (0, react_1.useEffect)(function () {
        onChange === null || onChange === void 0 ? void 0 : onChange({ target: { value: value } });
    }, [value]);
    return (react_1.default.createElement(form_field_set_component_1.FormFieldSet, null, react_1.default.Children.map(children, function (child, i) {
        var isLast = i + 1 === children.length;
        var isFirst = i === 0;
        if (react_1.default.isValidElement(child)) {
            return react_1.default.cloneElement(child, {
                bottomBorder: !isLast,
                isFirst: isFirst,
                isLast: isLast,
                isFocused: isFocused,
                name: name,
                checked: value === child.props.value,
                onChange: function (e) { return setValue(e.target.value); },
            });
        }
        return child;
    })));
});
// const base = " ";
// const notFocused = " ";
// const focus = " ";
// const getClasses = ({ isFocused }: { isFocused: boolean }) => {
//   return classNames(base, {
//     [focus]: isFocused,
//     [notFocused]: !isFocused,
//   });
// };
exports.Radios = Object.assign(exports._Radios, {
    css: {
    // base,
    // notFocused,
    // focus,
    },
    WithFormManager: (0, with_form_manager_1.withFormManager)(exports._Radios),
    displayName: "VistoRadios",
});
